import { fetchAuthSession } from "aws-amplify/auth";
import { getIdToken } from "../userAuth";

export const requestHandler = async (
  url,
  method,
  body,
  invalidateCache,
  disableAuth,
) => {
  let authorizationToken = null;
  if (!disableAuth) {
    try {
      const idToken = await getIdToken();
      authorizationToken = idToken;
    } catch (error) {
      const { identityId } = await fetchAuthSession({ forceRefresh: true });
      authorizationToken = identityId;
    }
  }
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: authorizationToken,
        ...(invalidateCache && { "Cache-Control": "max-age=0" }),
      },
      ...(body && { body: JSON.stringify(body) }),
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const apiRequest = async (
  url,
  method,
  body,
  disableAuth,
  invalidateCache,
) => {
  try {
    const response = await requestHandler(
      url,
      method,
      body,
      invalidateCache,
      disableAuth,
    );
    if (response.status === 200 || response.status === 201) {
      return response.json();
    }
    if (response.status === 404) {
      return {};
    }
    throw Error(`${response.status} ${response.statusText}`);
  } catch (error) {
    if (!invalidateCache && method === "GET") {
      // Try GET request again with cache disabled
      const retryResponse = await requestHandler(
        url,
        method,
        body,
        true,
        disableAuth,
      );
      if (retryResponse.status === 200 || retryResponse.status === 201) {
        return retryResponse.json();
      }
      if (retryResponse.status === 404) {
        return {};
      }
    }
    throw error;
  }
};

export default apiRequest;
